import React, { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import BasicButton from 'components/Button/BasicButton';
import Row from 'components/common/Row';
import Divider from 'components/Divider';
import { formatModifyText } from 'utils/formatting';
import { Product, ProductState } from 'types/api';
import { getEnvConstant } from 'constants/env';
import { ModifyValue } from '../hooks/useProductDetaillHooks';
import HackleManager from 'utils/hackle';
import StatusButton from 'containers/ProductList/components/StatusButton';
import { debounce } from 'lodash';

const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  padding: 24px 0 32px;
  width: 100%;
  max-width: 1200px;
  background-color: #fff;
  border-top: 1px solid #eaebec;
  border-right: 1px solid #eaebec;
`;

const ProductSaveButton = styled.button<{ $isAbled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  width: 82px;
  border-radius: 12px;
  background: ${props => (props.$isAbled ? '#1B1C1E' : '#f4f4f5')};

  color: ${props => (props.$isAbled ? '#fff' : '#dbdcdf')};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.6px;
`;

interface ProductBottomIProps {
  productInfo: Product;
  modifyValue: ModifyValue;
  handleUpdateProduct: () => void;
  setIsOpenConfirmDialog: Dispatch<SetStateAction<boolean>>;
}

const ProductBottom: React.FC<ProductBottomIProps> = props => {
  const {
    productInfo,
    modifyValue,
    handleUpdateProduct,
    setIsOpenConfirmDialog,
  } = props;

  const params = useParams<{ id: string }>();

  return (
    <BottomContainer>
      <div style={{ minWidth: '241px' }} />
      <Row
        justifyContent="space-between"
        style={{
          padding: '0 40px',
          width: '100%',
          height: '100%',
          maxWidth: '958px',
        }}
      >
        <StatusButton
          status={productInfo.status}
          style={{
            padding: '8px 12px',
            background: '#f7f7f8',
            borderRadius: '8px',
            border: 'none',
            fontWeight: '500',
          }}
        />
        <Row gap="16px">
          <Row gap="12px">
            {productInfo.status !== ProductState.CLOSED && (
              /* 판매 재시작하기 */
              <BasicButton
                content={`${formatModifyText(productInfo.status)}하기`}
                onClick={() => {
                  setIsOpenConfirmDialog(true);
                }}
                style={{
                  padding: '12px',
                  height: '48px',
                  borderRadius: '12px',
                }}
              />
            )}
            <BasicButton
              content={
                <a
                  href={`${getEnvConstant('webClientUrl')}/products/${
                    params.id
                  }`}
                  target="_blank"
                >
                  상품보기
                </a>
              }
              onClick={() => {}}
              style={{ padding: '12px', height: '48px', borderRadius: '12px' }}
            />
          </Row>
          {productInfo.status !== ProductState.CLOSED && (
            <Divider
              style={{ width: '1px', height: '24px', background: '#dbdcdf' }}
            />
          )}
          {productInfo.status !== ProductState.CLOSED && (
            /* 수정 후 저장 버튼 */
            <ProductSaveButton
              $isAbled={modifyValue.isModify}
              onClick={() => {
                if (modifyValue.isModify) {
                  handleUpdateProduct();

                  HackleManager.logProductModifySaveComplete(
                    Number(productInfo.id),
                    productInfo.title,
                  );
                }
              }}
              style={{ height: '48px' }}
            >
              저장
            </ProductSaveButton>
          )}
        </Row>
      </Row>
    </BottomContainer>
  );
};

export default ProductBottom;
